import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTabs } from '@shared/hooks/useTabs';

export const withOpenTab = <P extends { title?: string }>(Component: FC<P>, title?: string) => (props: P) => {
  const { pathname, search } = useLocation();
  const { openTab } = useTabs();

  useEffect(
    () => {
      openTab({
        title: title || props.title || 'test',
        route: `${pathname}${search}`, 
        replaceIfNotExist: true,
      });
    },
    []
  );

  return <Component {...props} />;
};